var exports = {
  "f": "DMListPageItems.module__accent___TXlzdT" + " " + __webpack_require__(367917)["LU"],
  "og": "DMListPageItems.module__accentIcon___TXlzdT",
  "Fv": "DMListPageItems.module__accentLabel___TXlzdT",
};

module.exports = exports;
